import { LABCORP_MVX_PLUS_URL } from './MetabolicVulnerability';

/**
 * References for the MVX Plus section. MVX isn't a Section, so it doesn't use the
 * DB-driven Reference Library (SECTION_Gn_NN tags); these live in a static module
 * and render via MvxReferencesSection. PubMed PMIDs verified 2026-07-24.
 * The GlycA validation papers underpin the inflammation (IVX) side; the Labcorp
 * page is the test vendor. Expand as more marker-specific citations are curated.
 */
export interface MvxReference {
  citation: string;
  url: string;
}

export const MVX_REFERENCES: MvxReference[] = [
  {
    citation: 'Labcorp. Metabolic Vulnerability Index (MVX) Plus by NMR — Test #123601.',
    url: LABCORP_MVX_PLUS_URL,
  },
  {
    citation:
      'Akinkuolie AO, Buring JE, Ridker PM, Mora S. A novel protein glycan biomarker and future cardiovascular disease events. J Am Heart Assoc. 2014;3(5):e001221.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/25249300/',
  },
  {
    citation:
      'Duprez DA, Otvos J, Sanchez OA, Mackey RH, Tracy R, Jacobs DR Jr. Comparison of the predictive value of GlycA and other biomarkers of inflammation for total death, incident cardiovascular events, noncardiovascular and noncancer inflammatory-related events, and total cancer events. Clin Chem. 2016;62(7):1020-1031.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/27173011/',
  },
];
